import i18next from 'i18next'
import * as React from 'react'

interface Props {
    description: string
    onBack: () => void
    onTryAgain: () => void
    title: string
}

export function FileGuideErrorModal(props: Props) {
    const { onBack, onTryAgain } = props

    return (
        <zaptic-modal z-index={3}>
            <div className="AppCore__guide__FileGuideErrorModal-container">
                <div className="AppCore__guide__FileGuideErrorModal-row-item">
                    <img className="AppCore__guide__FileGuideErrorModal-icon" src="/shared/images/cloud-cross.svg" />
                </div>
                <div className="AppCore__guide__FileGuideErrorModal-row-item">
                    <h3 className="AppCore__guide__FileGuideErrorModal-title AppCore__guide__FileGuideErrorModal-text">
                        {props.title}
                    </h3>
                    <div className="AppCore__guide__FileGuideErrorModal-description AppCore__guide__FileGuideErrorModal-text">
                        {props.description}
                    </div>
                </div>
                <div className="AppCore__guide__FileGuideErrorModal-row-item AppCore__guide__FileGuideErrorModal-actions">
                    <button className="AppCore__guide__FileGuideErrorModal-btn" onClick={onBack}>
                        {i18next.t('appcore:FileGuideErrorModal.goBack')}
                    </button>
                    <button
                        className="AppCore__guide__FileGuideErrorModal-btn AppCore__guide__FileGuideErrorModal-btn-purple"
                        onClick={onTryAgain}
                    >
                        {i18next.t('appcore:common.tryAgain')}
                    </button>
                </div>
            </div>
        </zaptic-modal>
    )
}
